const AppConstants = {
  jiraUrl:
    'https://tdf.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/o2joag/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=fr-FR&collectorId=5db5d780',
  opsProdUrl:
    'https://opstool.rcgwp.iasp.tgscloud.net/support/dafe69d2-787f-47c0-821a-23a11ef8a125',
  opsNonProdUrl:
    'https://opstool.rcgwd.iasp.tgscloud.net/support/dafe69d2-787f-47c0-821a-23a11ef8a125',
  appInsights: {
    pathList: [
      { name: 'Ticket List', path: '/' },
      { name: 'Ticket Details', path: '/ticket/details' },
      { name: 'Create Ticket', path: '/ticket/creation' },
      { name: 'Edit Ticket', path: '/ticket/edit' },
      { name: 'Wagon Research', path: '/wagon/search' },
      { name: 'Wagon Details', path: '/wagon/details' },
      { name: 'Invoices Research', path: '/invoices/research' },
      { name: 'Add Invoice', path: '/invoices/add' },
      {
        name: 'Analytics- Wagon Availability',
        path: '/analytics/wagon-availability',
      },
      {
        name: 'Analytics- Wagon Simulation',
        path: '/analytics/wagon-simulation',
      },
      {
        name: 'Analytics- Maintenance Status',
        path: '/analytics/maintenance-status',
      },
      {
        name: 'Analytics- Workshop Time',
        path: '/analytics/workshop-time',
      },
      {
        name: 'Analytics- Total Cost Of Ownership',
        path: '/analytics/total-cost',
      },
      {
        name: 'Analytics- Monitoring',
        path: '/analytics/monitoring',
      },
    ],
    userGroups: [
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-ALL-FLEETMNGT',
        site: 'ALL',
        role: 'Fleet Manager',
        persona: 'Emily',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-NOR-SITEOPT',
        site: 'Normandie',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-NOR-SUPERSITEOPT',
        site: 'Normandie',
        role: 'Admin Internal Site Operator',
        persona: 'Super Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-LEU-SITEOPT',
        site: 'Leuna',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-ITCRUBIS-SITECOSOPT ',
        site: 'ITC RUBIS',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-SEATANK-SITECOSOPT',
        site: 'SEATANK',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'TA-WOLF-DEVTEAM-SITECOSOPT',
        site: 'DevTeam',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-DEVTEAM-SITECOSOPT',
        site: 'DevTeam',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-CLN-SITEOPT',
        site: 'Carling',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-DGS-SITEOPT',
        site: 'Donges',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-FZN-SITEOPT',
        site: 'Feyzin',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-LAVERA-SITEOPT',
        site: 'Lavera',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-MED-SITEOPT',
        site: 'La Mede',
        role: 'Internal Site Operator',
        persona: 'Max',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-ARLANXEOLILLEBONNE-SITECOSOPT',
        site: 'Arlanxeo Lillebonne',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-SEQENS-SITECOSOPT',
        site: 'Seqens',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-OILTANKINGSTOLTHAVEN-SITECOSOPT',
        site: 'Oiltanking Stolthaven',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-ARLANXEOLAWANTZENAU-SITECOSOPT',
        site: 'Arlanxeo La Wantzenau',
        role: 'External Site Operator',
        persona: 'Dave',
      },
      {
        group: 'AG-FRTPPAP-LISTA-WOLF-MICHELINSIMOREP-SITECOSOPT',
        site: 'Michelin Simorep',
        role: 'External Site Operator',
        persona: 'Dave',
      },
    ],
  },
  help: {
    helpLinks: [
      {
        title: 'Report a bug/incident',
        link: 'https://itsm.hubtotal.net/sp?id=sc_cat_item&sys_id=a64c8e302915270018d47222ca367aea&kb_article_id=1b882df31bee2090eea696859b4bcb2d',
      },
      {
        title: 'User guide',
        link: 'https://teams.microsoft.com/_#/files/Users%20Guides%20%40%20WOLF?threadId=19%3A7beed1ece53a44f9bc93530672cfd86a%40thread.tacv2&ctx=channel&context=Users%2520Guides%2520%2540%2520WOLF&rootfolder=%252Fsites%252FWOLFRCbyOAL%252FDocuments%2520partages%252FUsers%2520Guides%2520%2540%2520WOLF',
      },
    ],
  },
};
export default AppConstants;
